export function isTotalRow(rowItem) {
  return rowItem && rowItem.RowType === 'Total';
}

export function isNormalRow(rowItem) {
  return rowItem && rowItem.RowType === 'Normal';
}

export function isAggregatedOthersRow(rowItem) {
  return rowItem.RowType === 'AggregatedOthers';
}
